import { render } from "./Capcalera.vue?vue&type=template&id=0b057606&scoped=true"
import script from "./Capcalera.vue?vue&type=script&lang=js"
export * from "./Capcalera.vue?vue&type=script&lang=js"

import "./Capcalera.vue?vue&type=style&index=0&id=0b057606&scoped=true&lang=css"

import exportComponent from "/root/apps/cantic/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b057606"]])

export default __exports__